import { observer } from 'mobx-react';

import { InitialStoreSelectorModalTranslation } from '../../../localization/SiteTranslation';
import { UnderlineLink } from '../../../shared/components/UnderlineLink/UnderlineLink';
import { InitialStoreSelectorModalState, ISelectItem } from '../InitialStoreSelectorModalState';

interface IGoToInternationalStoreButtonStore {
  modal: InitialStoreSelectorModalState;
  onSelect: (store: ISelectItem) => void;
  translation: InitialStoreSelectorModalTranslation;
}

export const GoToInternationalStoreButton = observer(
  ({ modal, onSelect, translation }: IGoToInternationalStoreButtonStore) => {
    const globalStore = modal.storeSelection.stores.find((x) => x.id === 'global' && x.countryCode === 'GLOBAL');

    const handleGoToInternationalPage = () => {
      onSelect({ label: globalStore.name, value: globalStore.key });
      modal.apply();
    };

    return globalStore ? (
      <UnderlineLink onClick={handleGoToInternationalPage}>{translation.linkLabelInternationalStore}</UnderlineLink>
    ) : null;
  },
);
